import { FC } from 'react'

import cls from './style.module.scss'

type DescriptionNoteProps = {
	description?: string
}

export const DescriptionNote: FC<DescriptionNoteProps> = ({ description }) => (
	<section className={cls.root}>
		<p>{description}</p>
	</section>
)
